<template>
  <div class="cookie-banner">
    <vue-markdown
      class="cookie-banner__text"
      :source="text"
      v-font-style="fontStyles('normal')"
    />
    <btn
      class="cookie-banner__button"
      :backgroundColor="secondaryColor"
      :text="buttonText"
      @click.native="accept"
    />
    <icon
      class="cookie-banner__close"
	    icon="close"
			data-element="close"
      alt="Close"
			size="md"
			clickable="true"
			:iconColor="secondaryColor"
      @click.native="reject"
		/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import VueMarkdown from 'vue-markdown';

const Btn = () => import('@/components/ui/Btn');
const Icon = () => import('@/components/ui/Icon');

export default {
  name: 'CookieBanner',
  data () {
    return {
      defaultText: `by selecting 'accept cookies' you agree to the storing of cookies, which personalise content to you, enhance site navigation, analyse site usage/traffic + assist our marketing efforts. to find out more <a href="/terms" title="Read our terms and conditions">click here</a>`,
      defaultButtonText: 'I accept cookies'
    };
  },
  computed: {
    ...mapGetters({
      fontStyles: 'ui/getBodyCopyFontDetail',
      secondaryColor: 'ui/getSecondaryColor',
      cookieFields: 'ui/getCookieBannerFields'
    }),
    text () {
      return this.cookieFields && this.cookieFields.text || this.defaultText;
    },
    buttonText () {
      return this.cookieFields && this.cookieFields.buttonText || this.defaultButtonText;
    }
  },
  methods: {
    ...mapActions({
      accept: 'ui/acceptCookieConsent',
      reject: 'ui/rejectCookieConsent'
    })
  },
  components: {
    Btn,
    Icon,
    VueMarkdown
  }
};
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/variables.scss';
  @import '@/assets/scss/helpers.scss';

  .cookie-banner {
    width: 100%;
    color: $white;
    background: $black;
    padding: 15px;
    position: fixed;
    left: 0;
    bottom: 0;

    @include whenScreenIs(md) {
      display: flex;
      align-items: center;
    }
    
    &__text {
      margin-bottom: 1.25rem;

      @include whenScreenIs(md) {
        flex: 0 0 75%;
        margin-left: auto;
        margin-right: 0;
      }

      /deep/ a {
        color: inherit;
        text-decoration: underline;

        &:hover {
          @media (pointer: fine) {
            text-decoration: none;
          }
        }
      }
    }

    &__button {
      @include whenScreenIs(md) {
        margin-left: auto;
        margin-right: 0;
      }
    }

    &__close {
      background-color: $white;
      border-radius: 50%;
      border: 1px solid $black;
      position: absolute;
      top: 0;
      right: 15px;
      transform: translate(0,-50%);
    }
  }
</style>
